<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare class="m-b-20" content='1、勾选并保存［自助生成券码］后，不支持修改此购物券的面值、使用条件和有效期。（表示券已对外投放）
  2、如未生成券码：
  （1）未同步微信卡券情况下：购物券领取数量为0时，支持修改此购物券的所有内容；购物券领取数量大于0时，仅支持修改券名称、适用商品、使用说明、跳转链接、备注及同步卡券，支持生成券码。
  （2）已同步微信卡券情况下：仅支持修改卡券颜色、商户logo、使用说明和备注，支持生成券码。
  （3）云店小程序使用的购物券暂不支持使用券码。' :padding='false'></SmallSquare>
      <app-warp title='购物券详情' color='#efefef'>
        <template #app-content>
          <div class="p15">
            <div class="couponBox s_bf width100 s_po_re ">
              <div class="coupon_one ptb-20">
                <p class="fz-12 s_c666 p-t-20 text-ac">{{form.name || '这里显示购物券名称'}}</p>
                <p class="ptb-20 s_c333 text-ac fz-18"><span class="fz-40 s_font_b">{{form.price || 0}}</span>元</p>
                <p class="fz-12 s_c666 p-b-10 text-ac" v-if='form.condition == 2'>满{{form.money || 'X'}}元可用</p>
                <p class="fz-12 s_c666 p-b-10 text-ac" v-else>无门槛</p>
                <p class="fz-12 s_c999 text-ac" v-if='form.time_type == 2'>有效期：{{time[0]}}至{{time[1]}}</p>
                <p class="fz-12 s_c999 text-ac" v-else>有效期：领取日起 {{day || 'X'}} 天内</p>
                <p class="width45 height-40 s_flex_center m-t-20 m-b-5 s_cfff fz-16 bor-rad-3 s_mauto"
                  style="background: #ff7e28;">立即使用</p>
                <p class="ban left"></p>
                <p class="ban right"></p>
              </div>
              <div class="coupon_two p-tb0-lr10">
                <p class="height-51 s_bor_b_cd9 s_flex_bian_c s_c666 fz-13" style="border-color: #f0f0f0;">
                  适用商品：{{form.product_type == 1 ? "全部商品":"部分商品"}}</p>
                <p class="height-46 s_bor_b_cd9 s_flex_bian_c s_c333 fz-13" style="border-color: #f0f0f0;">在线云店
                  <RightOutlined />
                </p>
                <p class="height-46 s_bor_b_cd9 s_flex_bian_c s_c333 fz-13" style="border-color: #f0f0f0;">我的购物券
                  <RightOutlined />
                </p>
                <p class="s_c666 p-t-15 p-b-15 fz-13">{{form.explain || '使用说明'}}</p>
              </div>
            </div>
            <p class="width95 height-40 s_flex_center m-t-20 m-b-5 s_cfff fz-16 bor-rad-3 s_mauto"
              style="background: #ff7e28;" v-if='form.is_synchro'>放入微信卡包</p>
          </div>
        </template>
        <template #app-extra v-if='form.is_synchro'>
          <div class="m-t-20 p-tb0-lr15">
            <p class="text-ac m-b-20">（以下微信卡券显示效果）</p>
            <div :style='"padding: 40px 10px 20px;background-color:"+form.colour'>
              <div class="s_bf s_po_re">
                <img class="width-50 height-50 logo" :src="info.picdomain+'/'+form.logo" alt="" v-if='form.logo'>
                <div class="width-50 height-50 logo s_bf7 s_flex_center" v-else>
                  <PictureOutlined class="fz-20 s_c999" />
                </div>
                <p class="text-ac s_c999 p-t-45 p-b-15">{{form.business_name || '商户名称'}}</p>
                <p class="text-ac s_c333 fz-26 p-b-25">{{form.name || '购物券名称'}}</p>
                <p class="width50 height-35 s_flex_center s_cfff fz-16 bor-rad-3 s_mauto"
                  :style='"background-color:"+form.colour'>立即使用</p>
                <p class="s_c333 text-ac p-t-25 p-b-20" style="border-bottom: 1px dashed #dfdfdf;"
                  v-if='form.time_type == 2'>有效期：<span class="s_c999">{{time[0]}}至{{time[1]}}</span></p>
                <p class="s_c333 text-ac p-t-25 p-b-20" style="border-bottom: 1px dashed #dfdfdf;" v-else>有效期：<span
                    class="s_c999">领取日起 {{day || 'X'}} 天内</span></p>
                <div class="p-tb0-lr20 p-t-15 s_po_re">
                  <img class="width100 s_dis_b height-107" src="@/assets/images/bgmoren.jpg" alt=""
                    v-if='form.cover_image==""'>
                  <img class="width100 s_dis_b height-107" :src="info.picdomain+'/'+form.cover_image" alt="" v-else>
                  <div class="s_flex_bian_c height-30 s_po_ab_bl p-tb0-lr10"
                    style="background-color: rgba(0, 0, 0, .7);left: 20px;right: 20px;">
                    <p class="s_cfff width80 s_omit">{{form.cover_brief}}</p>
                    <RightOutlined class="s_cfff" />
                  </div>
                </div>
                <div class="p-tb0-lr20">
                  <p class="height-50 s_flex_bian_c " style="border-bottom:1px solid #f0f0f0;">优惠券详情
                    <RightOutlined class="s_c666" />
                  </p>
                  <p class="height-50 s_flex_bian_c ">公众号
                    <RightOutlined class="s_c666" />
                  </p>
                  <p class="height-50 s_flex_bian_c " style="border-top:1px solid #f0f0f0;" v-if='form.is_show'>小程序
                    <RightOutlined class="s_c666" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #app-sider>
          <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" style="margin-left:25px">
            <!-- 基本信息 -->
            <div class="mb25">
              <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 mb25">购物券信息</p>
              <div class="s_ptb0lr24">
                <a-form-item ref="name" label="购物券名称" name="name" help='建议涵盖券属性、服务及金额（具体优惠），限9个汉字或18个字母
                数字内。如券已成功同步到微信卡券，则不再支持修改券名称。'>
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-input v-model:value="form.name" placeholder='请输入购物券名称'
                        :disabled="synchType|| $route.query.type == 'look'" />
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item ref="price" label="面值" name="price">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-input-number class="width100" v-model:value="form.price"
                        :disabled="$route.query.type == 'edit' || $route.query.type == 'look'" v-inputFilter:price placeholder='请输入面值' />
                    </a-col>
                    <a-col :span="12">
                      <p>元</p>
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item ref="condition" label="使用条件" name="condition">
                  <a-radio-group v-model:value="form.condition"
                    :disabled="$route.query.type == 'edit' || $route.query.type == 'look'" @change="changeCondition">
                    <a-radio :value="1">
                      <span class="s_c333">无门槛</span>
                    </a-radio>
                    <a-radio :value="2">
                      <span class="s_c333">
                        订单金额满
                        <a-input-number class="width-150 m-l-10 m-r-10" style='display: inline-block;'
                          :disabled='form.condition !== 2 ||$route.query.type == "edit" || $route.query.type == "look"'
                          v-model:value="form.money" v-inputFilter:price placeholder='请输入金额' />
                        元可用
                      </span>
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item ref="verification_scene" label="核销场景" name="verification_scene">
                  <a-radio-group v-model:value="form.verification_scene"
                    :disabled="$route.query.type == 'edit' || $route.query.type == 'look'">
                    <a-radio :value="1">
                      <span class="s_c333">线上商城</span>
                    </a-radio>
                    <a-radio :value="2">
                      <span class="s_c333">线下核销</span>
                    </a-radio>
                  </a-radio-group>
                  <div>
                    <p class="height-25 s_c999">线上商城：支持在小程序商城购物结算时使用。</p>
                    <p class="height-25 s_c999">线下核销：支持线下到门店结算时核销后使用</p>
                  </div>
                </a-form-item>
                <a-form-item ref="is_synchro" label="同步发布到" name="is_synchro">
                  <a-checkbox v-model:checked="form.is_synchro" :disabled="synchType || $route.query.type == 'look'">
                    <span class="s_c333">微信卡券</span><span class="s_c999">（需要开通微信卡券权限 ，同步成功后，不支持去掉勾选）</span>
                  </a-checkbox>
                </a-form-item>
                <div v-if='form.is_synchro'>
                  <a-form-item ref="business_name" label="商户名称" name="business_name">
                    <a-row :gutter="16">
                      <a-col :span="12">
                        <a-input class="width100" v-model:value="form.business_name"
                          :disabled="synchType || $route.query.type == 'look'" placeholder='请输入商户名称' />
                      </a-col>
                      <a-col :span="12">
                        <p>(限12个汉字，同步后不可修改)</p>
                      </a-col>
                    </a-row>
                  </a-form-item>
                  <a-form-item ref="colour" label="卡券颜色" name="colour">
                    <div v-if='$route.query.type == "look"'
                      class="width-40 height-30 s_bor_cd9 bor-rad-5 s_flex_center m-t-5">
                      <div class="width-32 height-22" :style='"background-color:"+form.colour'></div>
                    </div>
                    <a-popover v-else>
                      <template #content>
                        <div class="width-150 clearfix">
                          <p class="s_shou width-20 height-20 m-l-5 m-r-5 m-b-5 fl" :style='"background-color:"+item'
                            v-for='item in colorList' :key='item' @click='selectColor(item)'></p>
                        </div>
                      </template>
                      <div class="width-40 height-30 s_bor_cd9 bor-rad-5 s_flex_center m-t-5">
                        <div class="width-32 height-22" :style='"background-color:"+form.colour'></div>
                      </div>
                    </a-popover>

                  </a-form-item>
                  <a-form-item ref="" label="商户LOGO" name="">
                    <img v-if='$route.query.type == "look" && form.logo' class="width-104 heiht-104"
                      :src="info.picdomain+'/'+form.logo" alt="">
                    <material v-else :groupType='1' :image="form.logo" :max="1"
                      v-on:handlechoose="(data)=>{form.logo=data}" v-on:handledel="form.logo=''" />
                  </a-form-item>
                  <a-form-item ref="" label="封面图片" name="">
                    <div class="coverBox s_po_re">
                      <img class="width100 s_dis_b height-107" :src="info.picdomain+'/'+form.cover_image" alt=""
                        v-if='form.cover_image'>
                      <img class="width100 s_dis_b height-107" src="@/assets/images/bgmoren.jpg" alt="" v-else>
                      <div class="s_flex_center height-30 width100 s_po_ab_bl p-tb0-lr10 s_cfff"
                        v-if='!synchType && $route.query.type !== "look"' style="background-color: rgba(0, 0, 0, .5);">
                        点击添加图片
                      </div>
                      <div class="s_po_ab_tl s_tou" v-if='!synchType && $route.query.type !== "look"'>
                        <material :size='{width:274,height:107}' :groupType='1' :image="form.cover_image" :max="1"
                          v-on:handlechoose="(data)=>{form.cover_image=data}" v-on:handledel="form.cover_image=''" /> />
                      </div>
                    </div>
                  </a-form-item>
                  <a-form-item ref="cover_brief" label="封面简介" name="cover_brief">
                    <a-row :gutter="16">
                      <a-col :span="12">
                        <a-input class="width100" v-model:value="form.cover_brief" :disabled="synchType"
                          placeholder='请输入封面简介' />
                      </a-col>
                      <a-col :span="12">
                        <p>(限12个汉字，同步后不可修改)</p>
                      </a-col>
                    </a-row>
                  </a-form-item>
                  <a-form-item ref="" label="小程序" name="">
                    <a-radio-group v-model:value="form.is_show" :disabled="$route.query.type == 'look'">
                      <a-radio :value="1">
                        <span class="s_c333">小程序</span>
                      </a-radio>
                      <a-radio :value="0">
                        <span class="s_c333">不显示</span>
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>
                </div>

              </div>
            </div>
            <div class="mb25">
              <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_font_b s_bf58 s_c333 mb25">购物券规则</p>
              <div class="s_ptb0lr24">
                <a-form-item ref="time_type" label="有效期" name="time_type">
                  <a-radio-group v-model:value="form.time_type"
                    :disabled="$route.query.type == 'edit' || $route.query.type == 'look'" @change="changDate">
                    <a-radio :value="1">
                      <span class="s_c333">
                        自领取日，有效
                        <a-input-number class="width-150 m-l-10 m-r-10" style='display: inline-block;'
                          :disabled="form.time_type !== 1 || $route.query.type == 'edit' || $route.query.type == 'look'"
                          v-model:value="day" :min='1' placeholder='请输入天数' />
                        天
                      </span>
                    </a-radio>
                    <p class="s_c999 m-l-20 m-t-15 m-b-15">（最多90天，适用于活动周期较长的活动，如全场景赋码的扫码活动）</p>
                    <a-radio :value="2">
                      <span class="s_c333 m-r-15">自定义有效期</span>
                      <a-range-picker @change="onChangeTime" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD'
                        :disabled="synchType || $route.query.type == 'edit' || $route.query.type == 'look'"
                        v-if='form.time_type == 2' v-model:value="time" />
                    </a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item ref="product_type" label="适用商品" name="product_type">
                  <a-radio-group v-model:value="form.product_type" :disabled="synchType || $route.query.type == 'look'">
                    <a-radio :value="1">
                      <span class="s_c333">全部商品</span>
                    </a-radio>
                    <a-radio :value="2">
                      <span class="s_c333">指定商品</span>
                    </a-radio>
                  </a-radio-group>
                  <div v-if='form.product_type == 2'>
                    <a-button type="primary" @click='showGood = true'
                      :disabled="synchType || $route.query.type == 'look'">添加指定商品</a-button>
                  </div>
                  <a-card title='商品列表' v-if='goodList.length > 0' class="m-t-25 s_marList">
                    <div class="s_flex_bian_c m-b-15 s_marListItem" v-for='(item,index) in goodList' :key='index'>
                      <p>{{item.product_name}}</p>
                      <a-button type="primary" size="small" @click='delGood(index)'
                        :disabled="$route.query.type == 'look'">删除</a-button>
                    </div>
                  </a-card>
                </a-form-item>
                <!-- <a-form-item ref="store_type" label="适用门店" name="store_type" >
                  <a-radio-group v-model:value="form.store_type" :disabled="synchType || $route.query.type == 'look'">
                    <a-radio :value="1">
                      <span class="s_c333">全部门店</span>
                    </a-radio>
                    <a-radio :value="2">
                      <span class="s_c333">指定门店</span>
                    </a-radio>
                    <a-radio :value="3">
                      <span class="s_c333">总部（选择总部，优惠券仅总部可用）</span>
                    </a-radio>
                  </a-radio-group>
                  <div v-if='form.store_type == 2'>
                    <a-button type="primary" @click='showStore = true' :disabled="synchType || $route.query.type == 'look'">添加门店</a-button>
                  </div>
                  <a-card title='门店列表' v-if='storeList.length > 0' class="m-t-25 s_marList">
                    <div class="s_flex_bian_c m-b-15 s_marListItem" v-for='(item,index) in storeList' :key='index'>
                      <p>{{item.store_name}}</p>
                      <a-button type="primary" size="small" @click='delStore(index)' :disabled="$route.query.type == 'look'">删除</a-button>
                    </div>
                  </a-card>
                </a-form-item> -->
                <a-form-item ref="explain" label="使用说明" name="explain">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-textarea v-model:value="form.explain" showCount :maxlength="200" placeholder="请输入使用说明"
                        :rows="4" :disabled="$route.query.type == 'look'" />
                    </a-col>
                  </a-row>
                </a-form-item>
                <!-- <a-form-item ref="" label="点击跳转" name="" >
                  <a-radio-group v-model:value="form.click_type" :disabled="$route.query.type == 'look'">
                    <a-radio :value="1" :disabled="form.is_synchro">
                      <span class="s_c333">H5云店</span>
                    </a-radio>
                    <a-radio :value="2" :disabled="form.is_synchro">
                      <span class="s_c333">积分商城</span>
                    </a-radio>
                    <a-radio :value="3">
                      <span class="s_c333">小程序云店</span>
                    </a-radio>
                    <a-radio :value="4">
                      <span class="s_c333">云店商城</span>
                    </a-radio>
                  </a-radio-group>
                </a-form-item> -->
                <a-form-item ref="remark" label="备注" name="remark">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-textarea v-model:value="form.remark" showCount :maxlength="200" placeholder="请输入备注" :rows="4"
                        :disabled="$route.query.type == 'look'" />
                    </a-col>
                  </a-row>
                </a-form-item>
              </div>
            </div>
            <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
              <a-button style="width:100px" class="m-r-20" @click="$router.go(-1)">
                返回
              </a-button>
              <a-button style="width:100px" type="primary" @click="onSubmit"
                v-if='$route.query.type == "add" || $route.query.type == "edit"'>
                保存
              </a-button>
            </a-form-item>
          </a-form>
        </template>
      </app-warp>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='goodList' :checkout="true"></selectGood>
  </a-modal>
  <a-modal  :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1300' :footer="null" destroyOnClose>
    <selectStore v-on:select="storeSelect" :selectList='storeList' :checkout='true'></selectStore>
  </a-modal>
</template>
<script>
  import moment from 'moment';
  import { RightOutlined, PictureOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { setCouponAdd, setCouponEdit, getCouponMore } from "@/api/assets";
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import store from "@/store"
  // 初始化默认筛选项数值
  let defForm = {
    name: '',
    price: '',
    condition: '',
    money: '',
    is_synchro: false,
    business_name: '',
    colour: '#63b359',
    logo: '',
    cover_image: '',
    cover_brief: '',
    is_show: '',
    time_type: '',
    day: '',
    product_type: '',
    product: [],
    store_type: '',
    store: [],
    explain: '',
    click_type: '',
    remark: '',
    verification_scene: ''
  }
  export default {
    components: {
      RightOutlined, PictureOutlined
    },
    setup() {
      const form = ref({ ...defForm });
      const state = reactive({
        day: '',
        info: store.state.user.info,
        synchType: false,
        colorList: ['#63b359', '#2c9f67', '#509fc9', '#5885cf', '#9062c0', '#d09a45', '#e4b138', '#ee903c', '#f08500', '#a9d92d', '#dd6549', '#cc463d', '#cf3e36', '#5E6671'],
        showGood: false,
        showStore: false,
        goodList: [],
        storeList: [],
        time: [],
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        start_time: '',
        end_time: "",
        rules: {
          name: [
            { required: true, message: '请输入购物券名称', },
          ],
          time_type: [
            { required: true, message: '请选择有效期', },
          ],
          product_type: [
            { required: true, message: '请选择使用商品', },
          ],
          explain: [
            { required: true, message: '请输入使用说明', },
          ]
        }
      });
      const ruleForm = ref()
      const $route = inject('$route')
      const $Modal = inject('$Modal')
      const $router = inject('$router')
      const _lodash = inject("_lodash");
      const selectColor = (e) => {
        form.value.colour = e
      }
      const storeSelect = (e) => {
        if (e) {
          state.showStore = false
        }
      }
      const delStore = (index) => {
        state.storeList.splice(index, 1)
      }
      const goodSelect = (e) => {
        state.goodList = e
        state.showGood = false
      }
      const delGood = (index) => {
        state.goodList.splice(index, 1)
      }
      const getMore = async (id) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getCouponMore(id).then(res => res.data);
        if (iscode(res)) {
          if (res.data.values.time_type == 2) {
            state.time = res.data.values.day.split(',')
          } else {
            state.day = res.data.values.day
          }
          if (res.data.values.is_synchro == true) {
            state.synchType = true
          }
          form.value = res.data.values
          state.goodList = res.data.values.product
          state.storeList = res.data.values.store
          setTimeout(hide);
        } else {
          message.error(res.msg);
          setTimeout(hide);
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if (form.value.time_type == 2) {
            form.value.day = state.time[0] + ',' + state.time[1]
          } else {
            form.value.day = state.day
          }
          form.value.product = _lodash.map(state.goodList, 'id')
          form.value.store = _lodash.map(state.storeList, 'id')
          if ($route.query.type == 'add') {
            res = await setCouponAdd({ values: JSON.stringify(form.value) }).then(res => res.data);
          } else {
            res = await setCouponEdit({ id: $route.query.id, values: JSON.stringify(form.value) }).then(res => res.data);
          }
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            setTimeout(() => {
              $router.go(-1)
            }, 1000);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        if ($route.query.type == 'edit' || $route.query.type == 'look') {
          getMore($route.query.id);
        }
      })
      const changDate = (e) => {
        if (e.target.value == 2) {
          state.day = ''
        } else {
          state.time = []
        }
      }
      //切换使用条件
      const changeCondition = (e) => {
        if (e.target.value == 1) {
          form.value.money = ''
        }
      }
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        selectColor,
        storeSelect,
        goodSelect,
        delStore,
        changDate,
        delGood,
        changeCondition
      }
    }
  }
</script>
<style lang="less" scoped>
  .couponBox .coupon_one {
    border-bottom: 1px dashed #dedede;
    position: relative;
  }

  .couponBox .coupon_one .ban {
    width: 10px;
    height: 20px;
    background-color: #efefef;
    display: block;
    position: absolute;
    bottom: -10px;
    z-index: 1;
  }

  .couponBox .coupon_one .ban.right {
    right: -2px;
    -webkit-border-radius: 20px 0 0 20px;
    border-radius: 20px 0 0 20px;
  }

  .couponBox .coupon_one .ban.left {
    left: -2px;
    -webkit-border-radius: 0 20px 20px 0;
    border-radius: 0 20px 20px 0;
  }

  .couponBox:after {
    content: "";
    width: 100%;
    height: 4px;
    background: url('../../../../assets//images/ta.png') -9px 0 / auto 100%;
    position: absolute;
    top: -4px;
    left: 0;
  }

  .logo {
    border-radius: 100%;
    position: absolute;
    left: 50%;
    top: -25px;
    transform: translateX(-50%);
  }

  .coverBox {
    width: 274px;
    height: 107px;
    border: 1px dashed #ddd;
  }
</style>